import useScrollReset from '../../contextapi/hooks/useScrollReset';

const ScrollReset = () => {
  useScrollReset();

  return null;
};

export default ScrollReset;
